<template>
    <ContainerLayout page="1" :loading="loading">
        <template v-slot:navbar>
            <nav class="h-100 navbar navbar-expand navbar-light bg-white text-dark">
                <div class="h-100 d-flex justify-content-start mt-3">
                    <img id="profile-img" class="profile-img-home" src="//ssl.gstatic.com/accounts/ui/avatar_2x.png" />
                </div>
                <div class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <small class="nav-link text-dark pt-1">
                            <small style="font-size: 12px;">{{ greetingLabel }}{{ currentUser ? ', ' : '' }}</small>
                            <br v-if="currentUser" />
                            {{ currentUser ? currentUser.name : '' }}
                        </small>
                    </li>
                </div>
                <div class="h-100 d-flex justify-content-start navbar-nav ml-auto">
                    <NavbarNotification :loading="loading" />
                </div>
            </nav>
        </template>
        <div class="content">
            <!-- <div class="w-100 mb-4">
                <div class="w-100 d-flex flex-column">
                    <label class="text-main font-weight-bold">{{ $t('For You') }}</label>
                    <HomeProductCardList v-bind:loading="loading" v-bind:slug="'personal'"
                        v-bind:products="personal_products" />
                </div>
            </div> -->
            <div class="w-100">
                <div class="w-100 bg-main card" style="border-radius: 0.5rem 0.5rem 0 0 !important;">
                    <div v-if="currentCompany == null" class="py-2 px-3 d-flex justify-content-between align-items-center">
                        <small class="text-white">{{ $t('Register a company?') }}</small>
                        <router-link to="/company-registration" class="btn btn-sm btn-light ml-1" style="min-width: 99px;">
                            <span class="text-main">{{ $t('Register here') }}</span>
                        </router-link>
                    </div>
                    <!-- <div v-if="currentCompany && currentCompany.verified_at == null"
                        class="py-2 px-3 d-flex justify-content-between align-items-center">
                        <small class="text-white">{{ $t('Your company is being verified!') }}</small>
                        <router-link :to="{ path: '', query: { ...$route.query } }" class="btn btn-sm btn-light ml-1"
                            @click.prevent="checkVerification" :disabled="loading" style="min-width: 128px;">
                            <span class="text-main">{{ $t('Check verification') }}</span>
                        </router-link>
                    </div> -->
                    <!-- <div v-if="currentCompany && currentCompany.verified_at != null && currentCompany.total_branches == 0" -->
                    <div v-if="currentCompany && currentCompany.total_branches == 0"
                        class="py-2 px-3 d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                            <div class="rounded-circle bg-white d-flex justify-content-center align-items-center mr-2"
                                style="min-width: 25px; min-height: 25px; padding: 2px;">
                                <font-awesome-icon icon="building" class="text-main" style="font-size: 12px;" />
                            </div>
                            <small class="text-white no-wrap-left">{{ currentCompany.name }}</small>
                        </div>
                        <router-link to="/add-branch" class="btn btn-sm btn-light ml-1" style="min-width: 105px;">
                            <span class="text-main">{{ $t('Add Destination') }}</span>
                        </router-link>
                    </div>
                    <!-- <div v-if="currentCompany && currentCompany.verified_at != null && currentCompany.total_branches > 0" -->
                    <div v-if="currentCompany && currentCompany.total_branches > 0"
                        class="py-2 px-3 d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                            <div class="rounded-circle bg-white d-flex justify-content-center align-items-center mr-2"
                                style="min-width: 25px; min-height: 25px; padding: 2px;">
                                <img :src="currentCompany.image_url" class="img-fluid"
                                    style="width: 25px; height: auto; max-height: 25px;" />
                            </div>
                            <small class="text-white no-wrap-left">{{ currentCompany.name }}</small>
                        </div>
                        <div @click.prevent="changeBranch()" class="btn btn-sm btn-light ml-1"
                            style="min-width: 83px; cursor: pointer;">
                            <span class="text-main">
                                <span v-if="screen() == 'sm' && selected_branch.name.length > 30">
                                    {{ selected_branch.name.substring(0, 30) + '...' }}
                                </span>
                                <span v-else>
                                    {{ selected_branch.name }}
                                </span>
                                <font-awesome-icon v-if="modal_branch_opened == false" icon="chevron-down" class="ml-2" />
                                <font-awesome-icon v-else icon="chevron-up" class="ml-2" />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-100 mb-4 card" style="border-radius: 0 0 0.5rem 0.5rem !important;">
                <div class="w-100 d-flex flex-column p-3">
                    <!-- <label class="text-main font-weight-bold">{{ $t('For Company') }}</label> -->
                    <HomeProductCardList v-bind:loading="loading" v-bind:slug="'company'"
                        v-bind:products="company_products" />
                </div>
            </div>
        </div>
        <vue-bottom-sheet ref="modalBranch" :swipeable="false" :rounded="true" max-height="80vh"
            @opened="modal_branch_opened = true" @closed="modal_branch_opened = false">
            <div id="modal-main-branch" style="height: 80vh; max-height: 80vh;">
                <div v-if="branches">
                    <div id="modal-body-branch">
                        <div style="overflow-y: auto; height: 100%;">
                            <div v-for="(branch, index) in branches" :key="index"
                                class="d-flex flex-row justify-content-between align-items-center mb-2"
                                style="cursor: pointer;" @click.prevent="selectBranch(branch)">
                                <div class="w-100 card m-2"
                                    style="border-radius: 0.25rem; box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2); display: flex; flex-direction: column; justify-content: space-between;"
                                    :style="selected_branch.id == branch.id ? ' border: 1.5px solid #275D93;' : ' border: 1.5px solid rgba(0,0,0,.125);'">
                                    <div class="d-flex flex-row align-items-center p-2">
                                        <!-- <img id="profile-img" class="profile-img mr-3"
                                            src="//ssl.gstatic.com/accounts/ui/avatar_2x.png" /> -->
                                        <div class="d-flex flex-column px-2">
                                            <small v-if="branch.name" style="font-weight: 600;">
                                                {{ branch.name }}
                                            </small>
                                            <small v-if="branch.brand" style="font-size: 12px;">
                                                {{ branch.brand }}
                                            </small>
                                            <small v-if="branch.brand" style="font-size: 12px;">
                                                {{ branch.phone }}
                                            </small>
                                            <small v-if="branch.address" class="text-muted" style="font-size: 12px;">
                                                {{ branch.address }}
                                            </small>
                                            <small v-if="branch.receiver_name || branch.receiver_phone" class="mt-2"
                                                style="font-weight: 600; font-size: 12px;">
                                                {{ $t('PIC') }} :
                                            </small>
                                            <small v-if="branch.receiver_name" style="font-size: 12px;">
                                                {{ branch.receiver_name }}
                                            </small>
                                            <small v-if="branch.receiver_phone" style="font-size: 12px;">
                                                {{ branch.receiver_phone }}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="card-footer d-flex flex-row justify-content-center align-items-center p-2">
                                        <button class="btn btn-block"
                                            :class="selected_branch.id == branch.id ? 'btn-main' : 'btn-secondary'"
                                            @click.stop="selectBranch(branch, true)">
                                            <span v-if="selected_branch.id == branch.id">
                                                <div v-if="loading" class="dots-loading">
                                                    <span></span>
                                                    <span></span>
                                                    <span></span>
                                                </div>
                                                <span v-else>
                                                    {{ $t('Keep & Continue') }}
                                                </span>
                                            </span>
                                            <span v-else>
                                                {{ $t('Select & Continue') }}
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <router-link to="/add-branch"
                                class="d-flex flex-row justify-content-between align-items-center mb-2"
                                style="cursor: pointer; text-decoration: none;">
                                <div class=" w-100 card clickable m-2">
                                    <div class="d-flex flex-row align-items-center justify-content-center p-4">
                                        <font-awesome-icon icon="plus" class="text-main mr-2" style="padding-top: 2px;" />
                                        <small class="text-main font-weight-bold">
                                            {{ $t('Add Destination') }}
                                        </small>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div v-else class="px-4 py-3">
                    <label class="text-main font-weight-bold">{{ $t('Please register a company first!') }}</label>
                </div>
            </div>
        </vue-bottom-sheet>
    </ContainerLayout>
</template>

<script>
import ContainerLayout from "../ContainerLayout.vue";
import NavbarNotification from "../NavbarNotification.vue";
import CompanyService from "@/services/company.service";
import ProductService from "@/services/product.service";
import HomeProductCardList from "./HomeProductCardList.vue";
import { VueBottomSheet } from "@webzlodimir/vue-bottom-sheet";
import "@webzlodimir/vue-bottom-sheet/dist/style.css";
import { ref } from "vue";
import screenSize from "@/plugins/screen-size";

export default {
    name: "HomeIndex",
    components: {
        ContainerLayout,
        NavbarNotification,
        HomeProductCardList,
        VueBottomSheet,
    },
    computed: {
        currentUser() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user : null;
        },
        currentCompany() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user.company : null;
        },
        currentBranch() {
            return localStorage.getItem('branch') ? JSON.parse(localStorage.getItem('branch')) : null;
        },
        greetingLabel() {
            const currentTime = new Date();
            const currentHour = currentTime.getHours();

            // Good Morning, Good Afternoon, Good Evening and Good Night
            if (currentHour >= 5 && currentHour < 12) {
                return this.$t("Good Morning");
            } else if (currentHour >= 12 && currentHour < 18) {
                return this.$t("Good Afternoon");
            } else if (currentHour >= 18 && currentHour < 22) {
                return this.$t("Good Evening");
            } else {
                return this.$t("Good Night");
            }
        },
    },
    data() {
        return {
            loading: false,
            personal_products: [],
            company_products: [],
            branches: [],
            selected_branch: null,
            first_load_branch: false,
            modal_branch_opened: false,
        };
    },
    setup() {
        const modalBranch = ref(null);
        const openModalBranch = () => {
            modalBranch.value.open();
        };
        const closeModalBranch = () => {
            modalBranch.value.close();
        };

        const screen = () => {
            return screenSize.size;
        };

        return {
            modalBranch,
            openModalBranch,
            closeModalBranch,
            screen,
        };
    },
    created() {
        this.selected_branch = this.currentBranch;
        this.branches = this.currentCompany ? this.currentCompany.branches : [];

        this.loadData();
    },
    methods: {
        loadData() {
            this.loading = true;
            let loader = this.$loading.show();

            let location_id = this.selected_branch ? this.selected_branch.location_id : null;
            ProductService.getAllCategory('all', 1, 6, location_id)
                .then((response) => {
                    this.loading = false;
                    loader.hide();

                    if (response.data.status == "success") {
                        this.personal_products = response.data.data.personal_products.data;
                        this.company_products = response.data.data.company_products.data;
                    } else {
                        this.personal_products = [];
                        this.company_products = [];

                        this.$vueAlert.alert(response.data.message, null, 'error');
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    loader.hide();

                    let errorMessage = this.$t('An error occurred');
                    if (error.response) {
                        if (error.response.status == 401) {
                            this.$store.dispatch("auth/logout");
                            this.$router.push('/login');
                            return; // Exit the function after handling 401
                        }

                        // Check if the message is available in the error response
                        if (error.response.data && error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.response.statusText) {
                            // Fallback to statusText if message is not available
                            errorMessage = error.response.statusText;
                        }
                    } else if (error.message) {
                        // Fallback to error.message if response is not available
                        errorMessage = error.message;
                    }

                    this.$vueAlert.alert(errorMessage, null, 'error');
                });
        },
        checkVerification() {
            let loader = this.$loading.show();

            let data = {
                company_id: this.currentCompany.id,
            };
            CompanyService
                .isCompanyVerified(data)
                .then((response) => {
                    loader.hide();
                    if (response.data.status == "success") {
                        let loggedData = JSON.parse(localStorage.getItem('loggedData'));
                        loggedData.user.company = response.data.data;
                        localStorage.setItem('loggedData', JSON.stringify(loggedData));

                        this.$vueAlert.alert(response.data.message, null, 'success').then(() => {
                            this.$router.go();
                        });
                    } else {
                        this.$vueAlert.alert(response.data.message, null, 'warning');
                    }
                })
                .catch((error) => {
                    loader.hide();

                    let errorMessage = this.$t('An error occurred');
                    if (error.response) {
                        if (error.response.status == 401) {
                            this.$store.dispatch("auth/logout");
                            this.$router.push('/login');
                            return; // Exit the function after handling 401
                        }

                        // Check if the message is available in the error response
                        if (error.response.data && error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.response.statusText) {
                            // Fallback to statusText if message is not available
                            errorMessage = error.response.statusText;
                        }
                    } else if (error.message) {
                        // Fallback to error.message if response is not available
                        errorMessage = error.message;
                    }

                    this.$vueAlert.alert(errorMessage, null, 'error');
                });
        },

        changeBranch() {
            this.openModalBranch();

            setTimeout(() => {
                if (!this.first_load_branch) {
                    this.first_load_branch = true;

                    let bottomSheetPan = document.getElementsByClassName("bottom-sheet__pan")[0];
                    while (bottomSheetPan.firstChild) {
                        bottomSheetPan.removeChild(bottomSheetPan.firstChild);
                    }
                    bottomSheetPan.classList.add("d-flex", "align-items-center", "h-auto", "pt-2", "pb-0");

                    let closeButtonWrapper = document.createElement("div");
                    closeButtonWrapper.classList.add("d-flex", "w-100", "px-2", "pb-2");
                    closeButtonWrapper.style.borderBottom = "2px solid #e0e0e0";

                    let closeButton = document.createElement("div");
                    closeButton.classList.add(
                        "badge-custom",
                        "badge-outlined",
                        "badge-dark",
                    );
                    // closeButton.style.position = "absolute";
                    closeButton.style.left = "10px";
                    closeButton.style.top = "10px";
                    closeButton.style.cursor = "pointer";
                    closeButton.style.backgroundColor = "transparent";
                    closeButton.style.border = "none";
                    closeButton.style.fontSize = "22px";
                    closeButton.style.fontWeight = "500";
                    closeButton.innerHTML = 'x';

                    let detailText = document.createElement("span");
                    detailText.innerHTML = this.$t("Choose Destination");
                    detailText.style.marginLeft = "10px";
                    detailText.style.fontSize = "16px";
                    detailText.style.fontWeight = "700";

                    // Append the detailText element to closeButton
                    closeButton.appendChild(detailText);
                    closeButton.addEventListener("click", () => {
                        this.closeModalBranch();
                    });

                    closeButtonWrapper.appendChild(closeButton);
                    bottomSheetPan.appendChild(closeButtonWrapper);

                    let bottomSheetCardHeight = document.getElementsByClassName("bottom-sheet__card")[0].offsetHeight;
                    let bottomSheetPanHeight = document.getElementsByClassName("bottom-sheet__pan")[0].offsetHeight;
                    document.getElementById("modal-main-branch").style.height = (bottomSheetCardHeight - bottomSheetPanHeight) + "px";

                    let modalMainHeight = document.getElementById("modal-main-branch").offsetHeight;
                    document.getElementById("modal-body-branch").style.height = modalMainHeight + "px";
                }
            }, 10);
        },

        selectBranch(branch, close = false) {
            if (!this.loading) {
                if (this.selected_branch.id != branch.id) {
                    this.selected_branch = branch;
                    localStorage.setItem('branch', JSON.stringify(branch));
                    this.loadData();
                }
                if (close) {
                    setTimeout(() => {
                        this.closeModalBranch();
                    }, 250);
                }
            }
        },
    },
};
</script>

<style scoped>
.no-wrap-left {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 130px;

    @media (max-width: 767px) {
        display: none;
    }
}

@media (min-width: 768px) {
    .no-wrap-left {
        max-width: 200px;
    }
}
</style>